<div class="flex-row flex-space-between align-center custom-height">
    <span>{{ data.message }}</span>
    <button mat-button color="accent" (click)="dismiss()">{{ data.action }}</button>
</div>